/**
 * Costes de adquisición: lo que comparten el formulario del inmueble y la ficha.
 */

/**
 * Los costes de compra de casi cualquier piso en España. Son atajos: pulsar uno escribe el
 * concepto. Cualquier otro se escribe a mano.
 */
export const COST_SUGGESTIONS = [
  'Notaría',
  'Registro',
  'ITP',
  'Gestoría',
  'Comisión agencia',
  'Reforma',
  'Tasación',
];

/**
 * Conceptos que en realidad no dicen nada: el que puso la migración a los inmuebles que ya
 * tenían un único importe de costes, y los que pone la API o el formulario cuando una línea
 * llega sin nombre. La ficha los marca como «sin motivo» y ofrece ponerlo.
 */
const GENERIC_CONCEPTS = new Set(['costes de adquisición', 'costes de compra', 'otros costes', 'coste']);

export function isGenericConcept(concept: string): boolean {
  return GENERIC_CONCEPTS.has(concept.trim().toLowerCase());
}
